import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DateDataEntity } from '../../../../../models/data-entities';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import Workflow from 'esri/widgets/Editor/Workflow';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-date-data-entity-view',
    templateUrl: './date-data-entity-view.component.html',
    styleUrls: ['./date-data-entity-view.component.css'],
    standalone: false
})
export class DateDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  templateForPermitForm: boolean = false
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService,componentFactoryResolver, context);
     //added by juber 24-12-2025

    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
        //end by juber 24-12-2025
  }
  dateEntity: DateDataEntity;

  ngOnInit() {
    this.dateEntity = <DateDataEntity>this.entity;
  }

// added by Deepak 14-05-2026
  getEntityLabelText(): string {
    if (!this.entity) {
      return '';
    }

    let label = this.showLabel ? this.entity.label :'';

    // replicate required indicator
    if (this.entity.isRequired) {
      label = `${label} *`;
    }

    return label;
  }
  // end by Deepak 14-05-2026
}
